// extracted by mini-css-extract-plugin
export var book = "marion20250622-module--book--5ad2e";
export var container = "marion20250622-module--container--2b3c7";
export var headerContainer = "marion20250622-module--headerContainer--808a4";
export var image = "marion20250622-module--image--6e7e0";
export var imageContainer = "marion20250622-module--imageContainer--7db9e";
export var main = "marion20250622-module--main--7ed95";
export var text = "marion20250622-module--text--cbf90";
export var title = "marion20250622-module--title--63402";
export var upperContainer = "marion20250622-module--upperContainer--51d84";